import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Row, Col } from 'react-bootstrap';
import { shift } from '@floating-ui/react';
import { formatDateToYYYYMMDD } from '../../../../utils/dateUtils';

// react-datepicker v8's default middleware only includes flip/offset/arrow (no shift),
// so the calendar can overflow and get clipped off the left edge of the viewport.
// Adding `shift` keeps the popup within the viewport.
const popperModifiers = [shift({ padding: 8 })];

interface OrderDateRangePickerProps {
  startDate: string; // Expect YYYY-MM-DD or empty string
  endDate: string; // Expect YYYY-MM-DD or empty string
  onDateRangeChange: (startDate: string, endDate: string) => void;
}

export function OrderDateRangePicker(props: OrderDateRangePickerProps) {
  const { startDate, endDate, onDateRangeChange } = props;

  const currentStartDateAsDate = startDate ? new Date(startDate) : null;
  const currentEndDateAsDate = endDate ? new Date(endDate) : null;

  // Use the picked day's calendar components (not toISOString, which is UTC and would shift the
  // day back by one for UTC+ operators). The stored YYYY-MM-DD is treated as an SGT calendar day
  // downstream, so it must match the day the operator actually clicked.
  const handleStartDateChange = (date: Date | null) => {
    const newStartDateString = date ? formatDateToYYYYMMDD(date) : '';
    onDateRangeChange(newStartDateString, endDate || '');
  };

  const handleEndDateChange = (date: Date | null) => {
    const newEndDateString = date ? formatDateToYYYYMMDD(date) : '';
    onDateRangeChange(startDate || '', newEndDateString);
  };

  return (
    <Row className="g-1 mx-0" style={{ width: '240px' }}>
      <Col className="pe-1" style={{ width: '120px' }}>
        <div className="small text-muted mb-1 text-nowrap">Start Date</div>
        <DatePicker
          selected={currentStartDateAsDate}
          onChange={handleStartDateChange}
          selectsStart
          startDate={currentStartDateAsDate}
          endDate={currentEndDateAsDate}
          dateFormat="yyyy-MM-dd"
          placeholderText="Start date"
          className="form-control form-control-sm bg-gray-50 hover:bg-gray-100 text-sm p-1"
          showPopperArrow={false}
          popperModifiers={popperModifiers}
        />
      </Col>
      <Col style={{ width: '120px' }}>
        <div className="small text-muted mb-1 text-nowrap">End Date</div>
        <DatePicker
          selected={currentEndDateAsDate}
          onChange={handleEndDateChange}
          selectsEnd
          startDate={currentStartDateAsDate}
          endDate={currentEndDateAsDate}
          dateFormat="yyyy-MM-dd"
          placeholderText="End date"
          className="form-control form-control-sm bg-gray-50 hover:bg-gray-100 text-sm p-1"
          showPopperArrow={false}
          popperModifiers={popperModifiers}
        />
      </Col>
    </Row>
  );
}
